import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { login } from './services/api';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Drivers from './pages/Drivers';
import FleetDrivers from './pages/FleetDrivers';
import Fleets from './pages/Fleets';
import Vehicles from './pages/Vehicles';
import Customers from './pages/Customers';
import Rides from './pages/Rides';
import Payouts from './pages/Payouts';
import Referrals from './pages/Referrals';
import Settings from './pages/Settings';
import './styles.css';

function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async () => {
    if (!username || !password) { setError('VyplĹte vĹˇechna pole'); return; }
    const data = await login(username, password);
    if (data.success) {
      localStorage.setItem('adminToken', data.token);
      localStorage.setItem('adminUsername', username);
      onLogin(username);
    } else {
      setError('NesprĂˇvnĂ© pĹ™ihlaĹˇovacĂ­ Ăşdaje');
    }
  };

  return (
    <div className="login">
      <div className="login-box">
        <div className="logo">EURO<span>.taxi</span></div>
        <div className="logo-sub">AdministrĂˇtorskĂ˝ panel</div>
        <div className="form-group">
          <label className="form-label">UĹľivatelskĂ© jmĂ©no</label>
          <input
            type="text"
            placeholder="UĹľivatelskĂ© jmĂ©no"
            value={username}
            onChange={e => setUsername(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && document.getElementById('passInput').focus()}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Heslo</label>
          <input
            id="passInput"
            type="password"
            placeholder="Heslo"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
          />
        </div>
        {error && <div className="error-msg">{error}</div>}
        <button className="btn" style={{ marginTop: 8 }} onClick={handleLogin}>PĹ™ihlĂˇsit se â†’</button>
      </div>
    </div>
  );
}

export default function App() {
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem('adminToken'));
  const [username, setUsername] = useState(localStorage.getItem('adminUsername') || '');

  const handleLogin = (u) => { setUsername(u); setLoggedIn(true); };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUsername');
    setLoggedIn(false);
    setUsername('');
  };

  if (!loggedIn) return <LoginPage onLogin={handleLogin} />;

  return (
    <BrowserRouter>
      <div style={{ display: 'flex' }}>
        <Sidebar username={username} onLogout={handleLogout} />
        <div className="main">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/drivers" element={<Drivers />} />
            <Route path="/fleet-drivers" element={<FleetDrivers />} />
            <Route path="/fleets" element={<Fleets />} />
            <Route path="/vehicles" element={<Vehicles />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/rides" element={<Rides />} />
            <Route path="/payouts" element={<Payouts />} />
            <Route path="/referrals" element={<Referrals />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}
